export default "__VITE_ASSET__91a578e2__"